import { FullscreenManager } from '@ardoq/fullscreen-manager';
import { TooltipManager } from '@ardoq/tooltip';
import { MainPaneLoaderConnected } from 'streams/views/mainContent/MainPaneLoader';
import { BrokenImagePopover } from 'components/popover/brokenImagePopover';
import { ConditionalFormattingImageColorFilters } from 'views/ConditionalFormattingImageColorFilters';

export const MainViewChrome = () => (
  <>
    <FullscreenManager isActiveInFullscreen={true}>
      <TooltipManager />
    </FullscreenManager>
    <MainPaneLoaderConnected />
    <BrokenImagePopover />
    <ConditionalFormattingImageColorFilters />
  </>
);
